import { render } from "./ForgotPassword.vue?vue&type=template&id=0a6dc37d"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts"
script.render = render

export default script